import axios from "axios";
import { octaneApiBaseUrl } from "./utils/env";

export default axios.create({
  baseURL: octaneApiBaseUrl,
});
